
<template>
    <div>
    <NavBar></NavBar>
    <Breadcrumb></Breadcrumb>
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-3">
          <SideBar></SideBar>
        </div>
        <div class="col-lg-9 content">
          <div class="pages">
            <div>     
    <section id="ContactForm" class="section">
    <div class="container">
        <h1 class="main-title">{{ $t("jobApplication") }}</h1>
        <b-alert v-if="isSubmitted" show variant="success">{{ $t("yourApplicationHasBeenSent") }}</b-alert>
        <form  @submit.prevent="submitted">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="userName">{{ $t('jobAppFormLabels.name') }} *</label>
                        <input
                                type="text"
                                id="userName"
                                class="form-control col-sm-8"
                                v-model="userData.userName"
                                :class="{ errror: $v.userData.userName.$error }"
                                @blur="$v.userData.userName.$touch()">
                    </div>
                    <div v-if="$v.userData.userName.$error">
                       <p v-if="!$v.userData.userName.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.userNameRequired') }}</p>
                    </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="userSurname">{{ $t('jobAppFormLabels.surname') }} *</label>
                        <input
                                type="text"
                                id="userSurname"
                                class="form-control col-sm-8"
                                v-model="userData.userSurname" 
                                :class="{ errror: $v.userData.userSurname.$error }"
                                @blur="$v.userData.userSurname.$touch()">
                    </div>
                    <div v-if="$v.userData.userSurname.$error">
                                                    <p v-if="!$v.userData.userSurname.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.userSurameRequired') }}</p>
                                                </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="dateOfBirth">{{ $t('contactFormLabels.birthDate') }} *</label>
                          <input
                                                            type="date"
                                                            id="dateOfBirth"
                                                            class="form-control col-sm-8"  
                                                            v-model="userData.dateOfBirth"
                                                            :class="{ errror: $v.userData.dateOfBirth.$error }"
                                @blur="$v.userData.dateOfBirth.$touch()">
                                                </div>
                                                <div v-if="$v.userData.dateOfBirth.$error">
                                                    <p v-if="!$v.userData.dateOfBirth.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.birthDateRequired') }}</p>
                                                </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="education">{{ $t("education") }} *</label>
                        <select id="education" class="form-control col-sm-8" v-model="userData.education" 
                        :class="{ errror: $v.userData.education.$error }"
                                @blur="$v.userData.education.$touch()">
                            <option>{{ $t("jobAppFormLabels.education.education_1") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_2") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_3") }}</option>
                            <option>{{ $t("jobAppFormLabels.education.education_4") }}</option> 
                        </select>
                    </div>
                    <div v-if="$v.userData.education.$error">
                                                    <p v-if="!$v.userData.education.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.educationRequired') }}</p>
                                                </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="homeAddress">{{ $t('jobAppFormLabels.homeAddress') }} *</label><br>
                        <!-- Interpolation between <textarea>{{ test }}</textarea> doesn't work!-->
                        <textarea
                            id="homeAddress"
                            rows="5"
                            class="form-control col-sm-8"
                            v-model="userData.homeAddress" 
                            :class="{ errror: $v.userData.homeAddress.$error }"
                                @blur="$v.userData.homeAddress.$touch()">></textarea>
                     </div>
                     <div v-if="$v.userData.homeAddress.$error">
                                                    <p v-if="!$v.userData.homeAddress.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.homeAddressRequired') }}</p>
                                                </div>
                     <div class="form-group row">
                                                    <label class="col-sm-4 col-form-label blue" for="location">{{ $t('contactFormLabels.location') }} *</label>
                                                    <select id="location" class="form-control col-sm-8" v-model="selectedLocation"
                                                     :class="{ errror: $v.selectedLocation.$error }"
                                @blur="$v.selectedLocation.$touch()">
                                                        <option v-for="(location, key) in locations" :key="key"> {{ location }} </option>   
                                                    </select>
                                                </div>
                                                <div v-if="$v.selectedLocation.$error">
                                                    <p v-if="!$v.selectedLocation.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.selectedLocationRequired') }}</p>
                                                </div>
                    <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="town">{{ $t('jobAppFormLabels.town') }} *</label>
                        <input
                                type="text"
                                id="town"
                                class="form-control col-sm-8"
                                v-model="town" 
                                :class="{ errror: $v.town.$error }"
                                @blur="$v.town.$touch()">
                    </div>
                    <div v-if="$v.town.$error">
                                                    <p v-if="!$v.town.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.townRequired') }}</p>
                                                </div>
                     <div class="form-group row">
                        <label class="col-sm-4 col-form-label blue" for="militaryStatus">{{ $t("militaryStatus") }} *</label>
                        <select id="militaryStatus" class="form-control col-sm-8" v-model="userData.militaryStatus" 
                        :class="{ errror: $v.userData.militaryStatus.$error }"
                                @blur="$v.userData.militaryStatus.$touch()">
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_1") }}</option>
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_2") }}</option>
                            <option>{{ $t("jobAppFormLabels.militaryStatus.military_3") }}</option>
                        </select>
                    </div>
                    <div v-if="$v.userData.militaryStatus.$error">
                                                    <p v-if="!$v.userData.militaryStatus.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.militaryStatusRequired') }}</p>
                                                </div>
                    <div class="form-group row">
                                                    <label class="col-sm-4 col-form-label blue" for="phoneNumber">{{ $t('contactFormLabels.phoneNumber') }} *</label>
                                                    <input
                                                            type="number"
                                                            id="phoneNumber"
                                                            class="form-control col-sm-8"
                                                            v-model="userData.phoneNumber" 
                                                            :class="{ errror: $v.userData.phoneNumber.$error }"
                                                            @blur="$v.userData.phoneNumber.$touch()">
                                                </div>
                                                 <div v-if="$v.userData.phoneNumber.$error">
                                                    <p v-if="!$v.userData.phoneNumber.required" class="text-danger mb-3">{{ $t('jobAppFormLabels.phoneNumberRequired') }}</p>
                                                </div>

                      <div class="row">
                        <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                            <div class="col"></div>
                            <div class="col-xs-12 col-md-8 offset-md-4">
                               
                         <!--mine  -->     <vue-recaptcha
            ref="invisibleRecaptcha"
            @verify="onVerify"
            @expired="onExpired"
            size="invisible"
            :sitekey="this.sitekey">
          </vue-recaptcha>
                            </div>
                        </div>
            
                    </div>


                   
                   

                </div>
            </div>
                    
             <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-8 col-md-offset-2">
                  <div class="col"></div>
                    <div class="col-xs-12 col-md-8 offset-md-4">
                        <button :disabled="$v.$invalid" class="btn btn-primary w-50" @click.prevent="submitted">{{ $t('jobAppFormLabels.applyButton') }}</button>
                    </div>
                    <div v-if="$v.$anyError" class="text-danger text-center mb-3 mt-3">{{ $t('contactFormLabels.fillRequiredFields') }}</div>
                </div>
            </div>
        </form>
        <hr>
        <p><small>{{ $t('contactFormLabels.requiredFields') }}</small></p>
        <p><small>{{ $t('contactFormLabels.note') }}</small></p>

    </div>

    </section>
      
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios';

/* mine*/ 
import VueRecaptcha from 'vue-recaptcha';
import NavBar from "@/components/shared/NavBar.vue";
import Breadcrumb from "@/components/shared/Breadcrumb.vue";
import SideBar from "@/components/shared/SideBar.vue";
import Footer from "@/components/shared/Footer.vue";
import { required } from 'vuelidate/lib/validators';

    export default {
        data () {
            return {
              sitekey: '6LdePfYZAAAAAKQ9lqc2Dgyn4M29b3zCQGoFWA35',
                pageSlug: this.$route.params.slug,
                errors: [],
                FormResult: null,
                userData: {
                    userName: '',
                    userSurname: '',
                    dateOfBirth: '',  
                    education: '',
                    homeAddress: '',
                    militaryStatus: '', 
                    phoneNumber: '',
                    location: ''
                },
                isSubmitted: false,
                locations: ['ADANA', 'ADIYAMAN', 'AFYONKARAHİSAR', 'AĞRI', 'AMASYA', 'ANKARA', 'ANTALYA', 'ARTVİN', 'AYDIN', 'BALIKESİR', 'BİLECİK', 'BİNGÖL', 'BİTLİS', 'BOLU', 'BURDUR', 'BURSA', 'ÇANAKKALE', 'ÇANKIRI', 'ÇORUM', 'DENİZLİ', 'DİYARBAKIR', 'EDİRNE', 'ELAZIĞ', 'ERZİNCAN', 'ERZURUM', 'ESKİŞEHİR', 'GAZİANTEP', 'GİRESUN', 'GÜMÜŞHANE', 'HAKKARİ', 'HATAY', 'ISPARTA', 'MERSİN', 'İSTANBUL', 'İZMİR', 'KARS', 'KASTAMONU', 'KAYSERİ', 'KIRKLARELİ', 'KIRŞEHİR', 'KOCAELİ', 'KONYA', 'KÜTAHYA', 'MALATYA', 'MANİSA', 'KAHRAMANMARAŞ', 'MARDİN', 'MUĞLA', 'MUŞ', 'NEVŞEHİR', 'NİĞDE', 'ORDU', 'RİZE', 'SAKARYA', 'SAMSUN', 'SİİRT', 'SİNOP', 'SİVAS', 'TEKİRDAĞ', 'TOKAT', 'TRABZON', 'TUNCELİ', 'ŞANLIURFA', 'UŞAK', 'VAN', 'YOZGAT', 'ZONGULDAK', 'AKSARAY', 'BAYBURT', 'KARAMAN', 'KIRIKKALE', 'BATMAN', 'ŞIRNAK', 'BARTIN', 'ARDAHAN', 'IĞDIR', 'YALOVA', 'KARABüK', 'KİLİS', 'OSMANİYE', 'DÜZCE'],
                town: '',
                selectedLocation: ''
            }
        },
          head: {
  
script: [
            { type: 'text/javascript', src: 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit', async: true, body: true},
            { t: 'application/ld+json', i: '{ "@context": "http://schema.org" }' }
        ]
  },
        
   components: {
    NavBar,
    Breadcrumb,
    SideBar,
    VueRecaptcha,
    Footer
  },
     validations: {
            userData: {
              userName: {
                required
              },
              userSurname: {
                required
              },
              dateOfBirth: {
                required
              },  
              education: {
                required
              },
              homeAddress: {
                required
              },
              militaryStatus: {
                required
              }, 
              phoneNumber: {
                required
              },  
            },
            town: {
                required
              },
            selectedLocation: {
                required
              }   
        },
        
        
        methods: {
        submitted(e) {
            this.isSubmitted = true;
            e.preventDefault(); 
            this.$refs.invisibleRecaptcha.execute();
        },
        onVerify: function (recaptchaToken) {
        
            this.resetRecaptcha();
            
            let config = {
                    headers: {
                        "Authorization": "Token a042f5f600ac6e1adcaad065b8fb07be",
                        "Content-Type": "application/json"
                    }
                }
                let myData = {
                    content: 
                      'Name' + '=' + this.userData.userName + '&' 
                    + 'Surname' + '=' + this.userData.userSurname + '&' 
                    + 'dateOfBirth' + '='  + this.userData.dateOfBirth + '&' 
                    + 'Education' + '='  + this.userData.education + '&' 
                    + 'HomeAddress' + '='  + this.userData.homeAddress + '&' 
                    + 'Location' + '=' + this.selectedLocation + '&' 
                    + 'Town' + '=' + this.town + '&' 
                    + 'MilitaryStatus' + '=' + this.userData.militaryStatus + '&' 
                    + 'PhoneNumber' + '=' + this.userData.phoneNumber,
                    application: this.$application,
                    language: this.$t("languageCode"),
                    dynamicField: '5f0853c9fe81d510f4022f96'
                };
            
            let secondData = JSON.stringify(myData);
            let successMessage = this.$t('yourMessageHasBeenSent');
            let errorMessage = this.$t('errorMessage');
            
            axios.post('https://recaptcha-verifier.tavitlab.com',{
                        siteKey: this.sitekey,
                        captchaToken: recaptchaToken
            })
            .then(function (response) {
                if(response.data.result == true){

                    axios.post('https://api.tavakademi.com/forms', secondData, config)
                    .then(response =>{
                        if(response.data.result == true){
                            alert(successMessage);
                        } else {
                            alert(errorMessage);
                        }
                        document.location = document.location.href;
                    })
                    .catch(error => {
                        console.log(error)
                        alert(errorMessage);
                        document.location = document.location.href;
                    })
                    
                } else {
                    document.location = document.location.href;
                }
            })
            .catch(function (error) {
                console.log(error);
                document.location = document.location.href;
            });
        },
        onExpired: function () {
            this.resetRecaptcha();  
        },
        resetRecaptcha () {
          this.$refs.invisibleRecaptcha.reset()
        }
    }   
        
        
        
        
    }
   
</script>

<style>



</style>